import styled from "styled-components";
import { guidebookCollapseTokens } from "../../theme";

export const Block = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !["fontColor", "fontFamily", "fontSize", "fontWeight"].includes(prop),
})<{
  fontColor?: string;
  fontFamily?: string;
  fontSize?: string;
  fontWeight?: string;
}>`
  color: ${({ fontColor }) => fontColor || "inherit"};
  font-family: ${({ fontFamily }) => fontFamily || "inherit"};
  font-size: ${({ fontSize }) => fontSize || "inherit"};
  font-weight: ${({ fontWeight }) => fontWeight || "inherit"};
  overflow-wrap: anywhere;
`;

export const Preview = styled.p`
  margin: 0;
  line-height: ${guidebookCollapseTokens.lineHeight};
  white-space: pre-wrap;
`;

export const Toggle = styled.button`
  display: block;
  min-height: ${guidebookCollapseTokens.controlHeight};
  margin-top: ${guidebookCollapseTokens.gap};
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    text-decoration-thickness: ${guidebookCollapseTokens.emphasisWidth};
  }
  &:active {
    text-decoration: none;
  }
  &:focus-visible {
    outline: ${guidebookCollapseTokens.focusWidth} solid currentColor;
    outline-offset: ${guidebookCollapseTokens.focusOffset};
  }
`;
